import { serviceVersionOne, service } from 'Services/api/api.service';
import { TAX_YEAR } from 'Config';
import { CheckoutServiceType } from './types';

const BASE_ENDPOINT = '/payments';

const CheckoutService: CheckoutServiceType = {
  getPlans: () => service.get(`/plans`),
  getCustomer: () => serviceVersionOne.get(`${BASE_ENDPOINT}/customer`),
  getShippingData: () => serviceVersionOne.get(`${BASE_ENDPOINT}/customer`),
  checkoutSession: params => serviceVersionOne.post(`${BASE_ENDPOINT}/stripe/checkout`, params),
  checkoutPreviousYears: params =>
    serviceVersionOne.post(`/oneTimeProducts/previousYears/checkout`, params),
  saveShippingData: params =>
    serviceVersionOne.patch(`${BASE_ENDPOINT}/customer/shippingData `, params),
  savePayLater: params =>
    serviceVersionOne.post(`${BASE_ENDPOINT}/payLater/start`, { ...params, taxYear: TAX_YEAR }),
  getFlexInvoice: () => serviceVersionOne.get(`/invoices/plans/flex`),
  getResultPreviousYearsPercentage: params =>
    serviceVersionOne.post(`/oneTimeProducts/previousYears/price/calculate`, params),
  getPlanFlexInfo: () =>
    serviceVersionOne.get(`${BASE_ENDPOINT}/plans/flex`, {
      params: {
        taxYear: TAX_YEAR,
      },
    }),
  getUserComplex: () => service.get('/plans/user-tax-profile'),
  getUserSpeiOut: params => service.get('/payLater/speiOuts', { params }),
  getCep: params => service.get(`/payLater/speiOuts/${params.trackId}/ack`),
  getValidationClabe: ({ clabe }) =>
    service.get('/payLater/validations/clabeAccount', { params: { clabeAccount: clabe } }),
  subscribeLiteFlex: params =>
    serviceVersionOne.post(
      `/payments/subscriptions/deferred?taxYear=${params.taxYear}&type=${params.type}`
    ),
  createDomiciliation: () => service.post('/domiciliation', {}),
  getUserChargements: (recordId: string) => service.get(`/debt/${recordId}/chargements`),
  getUserAutorizedDomiciliations: () => service.get('/user-authorizations'),
  autoRenewal: ({ isAutoRenewalEnabled }) =>
    serviceVersionOne.patch('/payments/customer/auto-renewal', { isAutoRenewalEnabled }),
};

export default CheckoutService;
